import { render, staticRenderFns } from "./v-mini-card.vue?vue&type=template&id=8d8ed14a&scoped=true"
import script from "./v-mini-card.vue?vue&type=script&lang=js"
export * from "./v-mini-card.vue?vue&type=script&lang=js"
import style0 from "./v-mini-card.vue?vue&type=style&index=0&id=8d8ed14a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d8ed14a",
  null
  
)

export default component.exports